import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { FetchDataTypes } from "../api/api";
import { formateDataPrec } from "../utils/types";

const NetActivity = ({title}: any) => {
  const [userData, setUserData] = useState<any>(null);
  const selectedClient: any = Cookies.get("client");
  useEffect(() => {
    FetchDataTypes(
      "NetActivity",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    )
      .then((response) => response.json())
      .then((response) => {
        setUserData(response);
      });
  }, []);

  function currencyFormat(num: any) {
    return num?.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
  let formattedDate = "";
  function formatDate(currentDate: string): string {
    const date = new Date(currentDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${day}-${month}-${year}`;
  }

  if (userData) {
    formattedDate = formatDate(userData[0].endDate);
  }

  return (
    <div className="w-100 netActivity  d-flex">
      <div className="col-sm-12 col-xxl-3">
        <div className="card w-11/12">
          <div className="card-body">
            <div className="row">
              <div className="col mt-0">
                <h5 className="card-title text-start">{title ? title : "Balance"}</h5>
              </div>
              <div className="col-auto">
                <div className="avatar">
                  <div className="avatar-title rounded-circle bg-primary-dark">
                    <span className="align-middle" data-feather="truck">
                      $
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <h1 className="display-6 text-small mt-1 mb-0 text-start">
              {userData && (
                <div>{"$" + currencyFormat(userData[0].marketValue)}</div>
              )}
            </h1>
          </div>
        </div>
      </div>
      <div className="col-sm-12 col-xxl-3 mx-2">
        <div className="card w-11/12">
          <div className="card-body">
            <div className="row">
              <div className="col mt-0">
                <h5 className="card-title text-start">Net Activity (YTD)</h5>
              </div>
              <div className="col-auto">
                <div className="avatar">
                  <div className="avatar-title rounded-circle bg-primary-dark">
                    <span className="align-middle" data-feather="truck">
                      $
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <h1 className="display-6 text-small mt-1 mb-3 text-start">
              {userData && (
                <div>{"$" + currencyFormat(userData[0].activity)}</div>
              )}
            </h1>
            {/* <div className="mb-0 text-small text-start">
              <span className="text-success">
                <i className="mdi mdi-arrow-bottom-right"></i> 5.50%{" "}
              </span>{" "}
              More than usual net activity{" "}
            </div> */}
          </div>
        </div>
      </div>
      <div className="col-sm-12 d-none">
        <div className="card">
          <div className="card-body">
            <h1 className="display-6 mt-1 mb-0 activityValue">
              {userData && (
                <div>
                  <div className="mb-2 mt-1">
                    {"$" + currencyFormat(userData[0].contributions)}{" "}
                  </div>
                  <div className="">
                    {userData[0].redemptions >= 0 ? (
                      "$" + currencyFormat(userData[0].redemptions)
                    ) : (
                      <span className="text-danger sellValue">
                        {"(" +
                          "$" +
                          currencyFormat(userData[0].redemptions).slice(1) +
                          ")"}
                      </span>
                    )}
                  </div>
                </div>
              )}
            </h1>
            <div className="row">
              <div className="col mt-0">
                <h5 className="card-title">Cap Stock Activity</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-sm-12 col-xxl-3 mx-2">
        <div className="card w-11/12">
          <div className="card-body">
            <div className="row">
              <div className="col mt-0">
                <h5 className="card-title text-start">Gain/Loss (YTD)</h5>
              </div>
              <div className="col-auto">
                <div className="avatar">
                  <div className="avatar-title rounded-circle bg-primary-dark">
                    <span className="align-middle" data-feather="truck">
                      $
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <h1 className="display-6 text-small mt-1 mb-3 text-start">
              {userData &&
                (userData[0]?.gainLoss >= 0 ? (
                  "$" + currencyFormat(userData[0]?.gainLoss)
                ) : (
                  <span className="text-danger sellValue">
                    {"(" +
                      "$" +
                      currencyFormat(userData[0]?.gainLoss).slice(1) +
                      ")"}
                  </span>
                ))}
            </h1>
          </div>
        </div>
      </div>
      <div className="col-sm-12 col-xxl-3 mx-2">
        <div className="card w-11/12">
          <div className="card-body">
            <div className="row">
              <div className="col mt-0">
                <h5 className="card-title text-start">Returns (YTD)</h5>
              </div>
              <div className="col-auto">
                <div className="avatar">
                  <div className="avatar-title rounded-circle bg-primary-dark">
                    <span className="align-middle" data-feather="truck">
                      %
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <h1 className="display-6 text-small mt-1 mb-3 text-start">
            {/* {userData && (
                <div>
                  {currencyFormat(userData[0].rateOfReturn) + "%"}
                </div>
              )} */}

{userData &&
                (userData[0]?.gainLoss >= 0 ? (
                 currencyFormat(userData[0].rateOfReturn) + "%"
                ) : (
                  <span className="text-danger sellValue">
                    {"(" +
                      
                      currencyFormat(userData[0]?.rateOfReturn).slice(1) + "%" +
                      ")"}
                  </span>
                ))}
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export { NetActivity };
